export const getDeviceIdentity = (state) => state.device.common.deviceIdentity

export const getDeviceRealIdentity = (state) => state.device.common.deviceRealIdentity
